import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { SuccessFilledIcon, WarningTriangleIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { EConsentStatus } from '../../borrowersDelivery.constants';
import { BorrowersDeliveryStepTestIds } from '../../BorrowersDeliveryStep.testIds';

const CONFIG = {
  [EConsentStatus.CAPTURED]: {
    label: 'Captured',
    Icon: SuccessFilledIcon,
    color: ({ palette }) => palette.success.main,
  },
  [EConsentStatus.PENDING]: {
    label: 'Pending',
    Icon: WarningTriangleIcon,
    color: ({ palette }) => palette.warning.main,
  },
  [EConsentStatus.NOT_APPLICABLE]: {
    label: 'Not required',
    Icon: WarningTriangleIcon,
    color: ({ palette }) => palette.text.secondary,
  },
};

const containerStyles = color => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  color,
});

const labelStyles = color => ({ color, fontWeight: 600 });

const EConsentIndicator = ({ status }) => {
  const { label, Icon, color } = CONFIG[status] ?? CONFIG[EConsentStatus.PENDING];

  return (
    <Box data-testid={BorrowersDeliveryStepTestIds.SIGNER_ECONSENT} sx={containerStyles(color)}>
      <Icon size={IconSize[16]} />
      <Typography sx={labelStyles(color)} variant="regular12">
        {label}
      </Typography>
    </Box>
  );
};

EConsentIndicator.propTypes = {
  status: PropTypes.string,
};

export default memo(EConsentIndicator);
